import { BadgeIndianRupee, History, Handshake, Building2 } from "lucide-react";

const STATS = [
  { icon: BadgeIndianRupee, value: "₹77.9 Cr+", label: "Platform valuation, as featured in The Economic Times" },
  { icon: History, value: "7+ Years", label: "Track record in Indian franchise consulting & expansion" },
  { icon: Handshake, value: "₹100 / Trade", label: "Flat platform fee on secondary trades — no percentage brokerage" },
  { icon: Building2, value: "Bengaluru HQ", label: "4th Floor, Manasa Residency, Electronic City Phase 1" },
];

export default function TrustStats() {
  return (
    <section data-testid="trust-stats-section" className="py-24">
      <div className="mx-auto max-w-6xl px-4">
        <div className="grid items-center gap-12 lg:grid-cols-[0.9fr_1.1fr]">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange-600">The frantiger pedigree</p>
            <h2 className="font-heading mt-4 text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
              Backed by a name Indian franchises already trust
            </h2>
            <p className="mt-5 text-base leading-relaxed text-slate-600">
              fraction is built by frantiger — the franchise consulting platform that has helped
              hundreds of Indian brands and investors find each other since 2017, with verified
              listings, transparent data and a flat, transparent fee model.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-4">
              <img
                src="https://frantiger.biz/assets/startup-BbXnWuAa.webp"
                alt="Startup India recognised badge"
                className="h-14 w-auto rounded-xl"
                data-testid="startup-india-badge"
              />
              <img
                src="https://frantiger.biz/assets/bgTiger-BB-b7Syb.webp"
                alt="frantiger tiger mascot"
                className="h-20 w-auto"
                data-testid="frantiger-mascot"
              />
            </div>
          </div>
          <div className="grid gap-5 sm:grid-cols-2">
            {STATS.map(({ icon: Icon, value, label }, i) => (
              <div key={value} className={`clay-card rounded-3xl p-6 ${i % 2 ? "sm:translate-y-4" : ""}`} data-testid={`trust-stat-${i + 1}`}>
                <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-orange-100 text-orange-600">
                  <Icon className="h-5 w-5" />
                </span>
                <p className="font-heading mt-4 text-2xl font-black text-slate-900">{value}</p>
                <p className="mt-1.5 text-sm leading-snug text-slate-500">{label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
